/* Farooze reviews — list behaviour, lightbox, and customer media upload.

   Upload note: Shopify stores line-item-property files on its own CDN. We post the
   file to /cart/add.js, keep the url it returns, then delete the cart line. The file
   is not owned by the line, so it outlives it — verified against the live store
   before this shipped. No third-party service is involved. */
(function () {
  var root = document.getElementById('reviews');
  if (!root) return;

  var form = root.querySelector('[data-fz-form]');
  root.querySelectorAll('[data-fz-open-form]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      form.hidden = false;
      var field = form.querySelector('#FzName');
      if (field) field.focus();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  var more = root.querySelector('[data-fz-more]');
  if (more) {
    more.addEventListener('click', function () {
      root.querySelectorAll('[data-fz-item].is-hidden').forEach(function (li) { li.classList.remove('is-hidden'); });
      more.remove();
    });
  }

  if (location.search.indexOf('contact_posted=true') > -1 && form) {
    form.hidden = false;
    form.scrollIntoView({ block: 'center' });
  }

  /* ---------- lightbox ---------- */
  var box = root.querySelector('[data-fz-lightbox]');
  var stage = root.querySelector('[data-fz-lightbox-stage]');
  if (box && stage) {
    var closeBox = function () {
      stage.innerHTML = '';
      if (box.open) box.close();
    };
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-fz-zoom]');
      if (!t) return;
      var src = t.getAttribute('data-src');
      var kind = t.getAttribute('data-kind');
      stage.innerHTML = '';
      var node;
      if (kind === 'video') {
        node = document.createElement('video');
        node.controls = true; node.autoplay = true; node.playsInline = true;
      } else {
        node = document.createElement('img');
        node.alt = '';
      }
      node.src = src;
      stage.appendChild(node);
      if (typeof box.showModal === 'function') box.showModal();
    });
    var closeBtn = root.querySelector('[data-fz-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeBox);
    box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });
    box.addEventListener('close', function () { stage.innerHTML = ''; });
  }

  /* ---------- uploads ---------- */
  var up = root.querySelector('[data-fz-upload]');
  if (!up) return;

  var VARIANT = up.getAttribute('data-variant');
  var MAX_FILES = parseInt(up.getAttribute('data-max'), 10) || 4;
  var MAX_BYTES = 20 * 1024 * 1024;
  var IMAGE_RE = new RegExp('^image/');
  var VIDEO_RE = new RegExp('^video/');
  var input = up.querySelector('[data-fz-input]');
  var previews = up.querySelector('[data-fz-previews]');
  var statusEl = up.querySelector('[data-fz-status]');
  var urlField = up.querySelector('[data-fz-urls]');
  var drop = up.querySelector('.fz-upload__drop');
  var submit = root.querySelector('[data-fz-submit]');
  var urls = [];
  var pending = 0;

  function say(msg, bad) {
    statusEl.textContent = msg || '';
    statusEl.classList.toggle('is-error', !!bad);
  }
  function sync() {
    urlField.value = urls.join(', ');
    if (submit) {
      submit.disabled = pending > 0;
      submit.textContent = pending > 0 ? 'Uploading…' : 'Submit review';
    }
  }
  function purgeCart() {
    var body = { updates: {} };
    body.updates[VARIANT] = 0;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  /* If an earlier attempt died mid-flight, clear any stray line on load. */
  purgeCart();

  function uploadOne(file, tile) {
    var fd = new FormData();
    fd.append('id', VARIANT);
    fd.append('quantity', '1');
    fd.append('properties[_media]', file);
    return fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('Shopify would not accept that file');
        return r.json();
      })
      .then(function (j) {
        var url = j.properties && j.properties._media;
        if (!url) throw new Error('no file url returned');
        urls.push(url);
        tile.classList.remove('is-busy');
        tile.setAttribute('data-url', url);
        return purgeCart();
      })
      .catch(function (err) {
        tile.classList.remove('is-busy');
        tile.classList.add('is-error');
        say(file.name + ' could not be uploaded. ' + err.message, true);
        return purgeCart();
      })
      .then(function () {
        pending -= 1;
        sync();
        if (pending === 0 && !statusEl.classList.contains('is-error')) {
          say(urls.length === 1 ? '1 file attached.' : urls.length + ' files attached.');
        }
      });
  }

  function addFiles(list) {
    var files = Array.prototype.slice.call(list);
    files.forEach(function (file) {
      if (urls.length + pending >= MAX_FILES) { say('You can attach up to ' + MAX_FILES + ' files.', true); return; }
      if (file.size > MAX_BYTES) { say(file.name + ' is over 20MB, which is Shopify’s limit. Please use a smaller file.', true); return; }
      var isVideo = VIDEO_RE.test(file.type);
      if (!IMAGE_RE.test(file.type) && !isVideo) { say(file.name + ' is not a photo or video.', true); return; }

      var tile = document.createElement('li');
      tile.className = 'fz-upload__item is-busy';
      var media = document.createElement(isVideo ? 'video' : 'img');
      media.src = URL.createObjectURL(file);
      if (isVideo) { media.muted = true; media.playsInline = true; media.preload = 'metadata'; }
      else { media.alt = ''; }
      tile.appendChild(media);

      var kill = document.createElement('button');
      kill.type = 'button';
      kill.className = 'fz-upload__remove';
      kill.setAttribute('aria-label', 'Remove this file');
      kill.textContent = '×';
      kill.addEventListener('click', function () {
        var u = tile.getAttribute('data-url');
        if (u) urls = urls.filter(function (x) { return x !== u; });
        tile.remove();
        sync();
        say(urls.length ? urls.length + ' file(s) attached.' : '');
      });
      tile.appendChild(kill);
      previews.appendChild(tile);

      pending += 1;
      sync();
      say('Uploading…');
      uploadOne(file, tile);
    });
    input.value = '';
  }

  input.addEventListener('change', function () { addFiles(input.files); });

  ['dragenter', 'dragover'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); up.classList.add('is-drag'); });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); up.classList.remove('is-drag'); });
  });
  drop.addEventListener('drop', function (e) {
    if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
  });
})();